import { RouteRecordRaw } from 'vue-router';

export const COLLECTIONS_ROUTES = {
  // Main routes
  INDEX: '/collections',
  DETAILS: (stageId: string) => `/collections/${stageId}`,

  // Route names
  NAMES: {
    INDEX: 'CollectionsIndexView',
    DETAILS: 'CollectionDetailsView',
    CONNECTION: 'CollectionConnectionView',
    PERSONAL: 'PersonalCollectionsView',
    COMPANY: 'CompanyCollectionsView',
  },
} as const;

export const collectionsRoute: RouteRecordRaw = {
  name: 'CollectionsRouterView',
  path: COLLECTIONS_ROUTES.INDEX,
  component: () => import('@/modules/Collections/views/CollectionsRouterView.vue'),
  meta: {
    titleLocalizationKey: 'SKILLS.collections',
  },
  children: [
    {
      name: COLLECTIONS_ROUTES.NAMES.INDEX,
      path: '',
      component: () => import('@/modules/Collections/views/CollectionsIndexView.vue'),
      meta: {
        title: 'Collections',
      },
      redirect: '/collections/personal',
      children: [
        {
          name: COLLECTIONS_ROUTES.NAMES.PERSONAL,
          path: 'personal',
          component: {
            template: '',
          },
          meta: {
            title: 'Personal Collections',
          },
        },
        {
          name: COLLECTIONS_ROUTES.NAMES.COMPANY,
          path: 'company',
          component: {
            template: '',
          },
          meta: {
            title: 'Company Collections',
          },
        },
      ],
    },
    {
      name: COLLECTIONS_ROUTES.NAMES.DETAILS,
      path: ':stageId',
      component: () => import('@/modules/Collections/views/CollectionDetailsView.vue'),
      meta: {
        title: 'Create Collections',
      },
    },
  ],
};
